import moment from 'moment';

const MOMENT_CACHE = {};

export default function(datetime) {
    if(!MOMENT_CACHE[datetime])
        MOMENT_CACHE[datetime] = moment(datetime);
    
    return MOMENT_CACHE[datetime];
}